export const CalendlyLinks = {
  freeOnBoardingSession:
    'https://calendly.com/onboarding-roomvu/transform-social-media-ai',
  freeOnboardingActionPlanSession:
    'https://calendly.com/onboarding-roomvu/transform-social-media-ai?a2=I%27m%20coming%20to%20claim_ads.&utm_source=Inbound&utm_medium=Webinar&utm_campaign=Webinar&month=2024-06',
  designRVFeedback: 'https://calendly.com/design-rv/feedback',
  roomvuCS15min: 'https://calendly.com/d/3b9-bwb-657/support-session',
  roomvuSupportPlatinumDiamond:
    'https://calendly.com/roomvu-support/platinum-diamond',
  weeklyCeoDemo: 'https://calendly.com/samme/ceo-demo?back=1&month=2024-05',
  instagramAuditReviewSession:
    'https://calendly.com/onboarding-roomvu/instagram-audit-review-session-roomvu',
  brokerage30min: 'https://calendly.com/roomvubizdev/brokerage30min',
  smartAdsSupport: 'https://calendly.com/smartads-roomvu/smart-ads-support',
  vipSuccessGrowthSession:
    'https://calendly.com/roomvu-vip/vip-success-growth-session',
  supportSessionReception:
    'https://calendly.com/d/crt3-5wj-k9h/support-session-reception?month=2025-07',
};

export const SupportCalendlyLinks = {
  proPremium: 'https://calendly.com/d/3b9-bwb-657/support-session',
  platinumDiamond: 'https://calendly.com/roomvu-support/platinum-diamond',
};

export const CeoCalendlyLinks = {
  free: 'https://calendly.com/samme/ceo-demo?back=1&month=2024-05',
  paid: 'https://calendly.com/samme/roomvu-success-sessions',
  socialMediaTraining: 'https://calendly.com/samme/social-media-training',
  meeting: 'https://calendly.com/samme/meeting',
};
